// @flow
import React from 'react';
// Styles
import './InfoCards.css';

type InfoCard = {
  title: string,
  text: string,
  img: string,
};

type Props = {
  cards: InfoCard[],
};

const InfoCards = ({ cards }: Props) => {
  return (
    <div className="info-cards">
      {cards.map(({ title, img, text }) => (
        <div className="info-card" key={title}>
          <img src={img} alt={title} />
          <div className="info-card-content">
            <h6 className="info-card-content-title">
              {title}
              <span>{text}</span>
            </h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoCards;
